<template>
    <svg class="icon">
        <use :xlink:href="'#' + type"></use>
    </svg>
</template>

<script>
export default {
    name: 'SvgIcon',
    props: {
        type: String
    }
}
</script>
